import { CommonService, RepairOrderQuoteSubmitModel } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type RepairOrderQuoteInput = {
  requestBody?: RepairOrderQuoteSubmitModel;
};

export const useCommonRepairOrderQuotesMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CommonService.putCommonRepairOrderQuotes>>,
      QueryError,
      RepairOrderQuoteInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ requestBody }: RepairOrderQuoteInput) => {
      return CommonService.putCommonRepairOrderQuotes(requestBody);
    },
    {
      ...options,
      onSuccess: () => {
        toast.success('Successfully updated!');
      },
      onError: (error: QueryError) => {
        const message = formatErrorMessage(error);
        toast.error(message);
        console.error(message);
      }
    }
  );
